import React from "react";
import {
  RewardsAccountSelection as AccountSelection,
  useDeviceTypes,
} from "halifax";
import { getCurrentCorpAccount, isCorpTenant } from "@capone/common";

import { RewardsAccountSelectionConnectorProps } from "./container";
import {
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../../context/experiments";
import { AVAILABLE, getExperimentVariant } from "@capone/experiments";
import { ClientContext } from "../../../../App";
import { config } from "../../../../api/config";

export interface IRewardsAccountSelectionProps
  extends RewardsAccountSelectionConnectorProps {
  className?: string;
  popoverClassName?: string;
}

export const RewardsAccountSelection = (
  props: IRewardsAccountSelectionProps
) => {
  const {
    className,
    rewardsAccounts,
    selectedAccountReferenceId,
    fetchRewardsAccounts,
    setSelectedAccountReferenceId,
    popoverClassName,
  } = props;
  const { matchesMobile } = useDeviceTypes();
  const { sessionInfo, showCoreHomepage } = React.useContext(ClientContext);

  const expState = useExperiments();

  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  React.useEffect(() => {
    fetchRewardsAccounts();
  }, []);

  React.useEffect(() => {
    if (!isCorpTenant(config.TENANT) || rewardsAccounts.length === 0) {
      return;
    }

    const currentCorpAccount = getCurrentCorpAccount(rewardsAccounts, sessionInfo);
    const currentCorpAccountId = currentCorpAccount?.accountReferenceId;

    if (
      currentCorpAccountId &&
      currentCorpAccountId !== selectedAccountReferenceId
    ) {
      setSelectedAccountReferenceId(currentCorpAccountId);
    }
  }, [
    rewardsAccounts,
    selectedAccountReferenceId,
    sessionInfo,
    setSelectedAccountReferenceId,
  ]);

  return (
    <AccountSelection
      className={className}
      selectedAccountReferenceId={selectedAccountReferenceId}
      setSelectedAccountReferenceId={setSelectedAccountReferenceId}
      rewardsAccounts={rewardsAccounts}
      isMobile={matchesMobile}
      popoverClassName={popoverClassName}
      isXmodRedesign={isXmodRedesign}
      hideCardSelection={showCoreHomepage && matchesMobile}
    />
  );
};
